export default __webpack_public_path__ + "tumblr-logo.png";